import React from 'react'

import { Box } from '@usap/uicomponents'

import RemoveAndContinueShopping from './RemoveAndContinueShopping'
import ChangeShippingAddressOnPaypal from './ChangeShippingAddressOnPaypal'
import boxWrapperStyle from './style/constant'

const Actions = params => {
  const { data } = params
  const { items, source } = data || {}

  const isFromPaypal = source && (source === 'paypal-CS' || source === 'paypal-OOS')

  return (
    <Box pad="small">
      {isFromPaypal === true && (
        <Box pad={boxWrapperStyle.pad}>
          <ChangeShippingAddressOnPaypal />
        </Box>
      )}
      <Box pad={boxWrapperStyle.pad}>
        <RemoveAndContinueShopping data={items} />
      </Box>
    </Box>
  )
}

export default Actions
